const ContactLink = ({ styles, text, style }) => {
  return <a className={styles} style={style} href="mailto:sapioo.info@gmail.com">{text}</a>
}
export default ContactLink;